import styled from 'styled-components';

const StyledSideTable = styled.div`
  width: 100%;
  padding-inline: 6.9444%;
  padding-top: 51px;
  padding-bottom: 107px;
  margin: 0px;
  display: flex;
  justify-content: space-around;
  justify-items: center;
  flex-wrap: wrap;
  row-gap: 20px;
  font-family: 'Poppins';
  font-style: normal;
  background-color: #faf4f4;
`;

export default StyledSideTable;
